import { render, staticRenderFns } from "./weapp.vue?vue&type=template&id=5b9024f9&scoped=true&"
import script from "./weapp.vue?vue&type=script&lang=js&"
export * from "./weapp.vue?vue&type=script&lang=js&"
import style0 from "./weapp.vue?vue&type=style&index=0&id=5b9024f9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9024f9",
  null
  
)

export default component.exports